 
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { OfferPagePromoContainers } from './OfferPagePromoContainers';
import { actions } from './OfferPagePromoContainers.actions';
import {
    getHeaderNames,
    getLocales,
    getContainers
} from './OfferPagePromoContainers.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderNames,
    locales: getLocales,
    containers: getContainers
});

const OfferPagePromoContainersComponent = connect(
    function mapStateToProps(state, {onSave, showConstructor, showConstructorPromoCode, showConstructorPromoCodeList}) {
        return {
            ...mapStateToPropsSelectors(state),
            location: state.routingCompat,
            loading: state.containers.loading,
            totalPages: state.containers.total,
            onSave: onSave,
            showConstructor: showConstructor,
            showConstructorPromoCode: showConstructorPromoCode,
            showConstructorPromoCodeList: showConstructorPromoCodeList
        };
    },
    function mapDispatchToProps() {
        return {
            getContainers: actions.getContainers,
            getLocales: actions.getLocales,
            saveContainersPresets: actions.saveContainersPresets
        };
    }
)(OfferPagePromoContainers);

export default OfferPagePromoContainersComponent;
